import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevrons-up",
  "use": "chevrons-up-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"chevrons-up\">\n<path d=\"M17,12c-0.3,0-0.5-0.1-0.7-0.3L12,7.4l-4.3,4.3c-0.4,0.4-1,0.4-1.4,0s-0.4-1,0-1.4l5-5c0.4-0.4,1-0.4,1.4,0l5,5\n\tc0.4,0.4,0.4,1,0,1.4C17.5,11.9,17.3,12,17,12z\" />\n<path d=\"M17,19c-0.3,0-0.5-0.1-0.7-0.3L12,14.4l-4.3,4.3c-0.4,0.4-1,0.4-1.4,0s-0.4-1,0-1.4l5-5c0.4-0.4,1-0.4,1.4,0l5,5\n\tc0.4,0.4,0.4,1,0,1.4C17.5,18.9,17.3,19,17,19z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol